export default "__VITE_ASSET__DApkeSmz__"